import { render } from "./container-request-form.vue?vue&type=template&id=5b2709db&scoped=true"
import script from "./container-request-form.vue?vue&type=script&lang=js"
export * from "./container-request-form.vue?vue&type=script&lang=js"

import "./container-request-form.vue?vue&type=style&index=0&id=5b2709db&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2709db"]])

export default __exports__